"use client";

import { useLinkStatus } from "next/link";
import { useTranslations } from "next-intl";
import type { MouseEvent } from "react";

export function RouteLoadingSpinner() {
  const t = useTranslations("accessibility");

  return <RouteLoadingSpinnerView label={t("loading")} />;
}

export function RouteLoadingLinkStatus() {
  const { pending } = useLinkStatus();

  if (!pending) return null;

  return <RouteLoadingSpinner />;
}

export function preventCurrentRouteNavigation(event: MouseEvent<HTMLAnchorElement>) {
  if (window.location.href === event.currentTarget.href) event.preventDefault();
}

function RouteLoadingSpinnerView({ label }: { label: string }) {
  return (
    <div
      aria-label={label}
      className="route-loading fixed inset-0 z-[110] flex min-h-dvh w-full touch-none flex-col items-center justify-center bg-background px-6"
      role="status"
    >
      <span
        aria-hidden="true"
        className="route-loading-spinner"
      />
    </div>
  );
}
